// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V68As","right":"styles_right__SpI7h"};